import { DataServer } from "../../../config.axios";
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

interface TechnicalInspectionState {
  TechnicalInspectionData: {
    load: boolean;
    data: [];
  };
}

export const TechnicalInspectionDataSlice = createSlice({
  name: "TechnicalInspectionData",
  initialState: {
    TechnicalInspectionData: {
      load: false,
      data: [],
    },
  } as TechnicalInspectionState,
  reducers: {},
  extraReducers: (builder: any) => {
    builder
      .addCase(fetchTechnicalInspectionData.pending, (state: TechnicalInspectionState) => {
        state.TechnicalInspectionData.load = true;
      })
      .addCase(fetchTechnicalInspectionData.fulfilled, (state: TechnicalInspectionState, action: any) => {
        state.TechnicalInspectionData.data = action.payload;
        state.TechnicalInspectionData.load = false;
      })
      .addCase(fetchTechnicalInspectionData.rejected, (state: TechnicalInspectionState) => {
        state.TechnicalInspectionData.load = false;
      });
  },
});

export default TechnicalInspectionDataSlice.reducer;

export const fetchTechnicalInspectionData = createAsyncThunk(
  "TechnicalInspectionData/fetchTechnicalInspectionData",
  async (param: {apiParam: {project_pin: any, layout_id: any}}, thunkAPI) => {
    try {
      const { data } = await DataServer.post("api/getTechnicalInspectionData", {
        project_pin: param.apiParam.project_pin,
        layout_id: param.apiParam.layout_id
      });
      return data.data;
    } catch (error) {
    }
  }
);
